import { idmsApi } from "./api";
import { API_USER_ENDPOINT } from "../../constants/endpoints";
import { convertObjectToQueryParams } from "../../util/convertObjectToQueryParams";

const userApi = idmsApi.injectEndpoints({
  endpoints: (builder) => ({
    createUser: builder.mutation<void, CreateUser>({
      query: (request) => ({
        url: API_USER_ENDPOINT,
        method: "POST",
        body: request,
      }),
      invalidatesTags: ["User"],
    }),

    getUsers: builder.query<any, GetUsersSearchCriteria>({
      query: (getUsersSearchCriteria) =>
        `${API_USER_ENDPOINT}?${convertObjectToQueryParams(
          getUsersSearchCriteria
        )}`,
      providesTags: ["User"],
    }),

    updateUser: builder.mutation<any, RequireOnly<UpdateUser, "id">>({
      query: (request) => ({
        url: `${API_USER_ENDPOINT}/${request.id}`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: ["User"],
    }),

    toggleUser: builder.mutation<void, { userId: string[]; userToggleState: boolean; lockoutEndTime?: string }>(
      {
        query: (body) => ({
          url: `${API_USER_ENDPOINT}/toggleUser`,
          method: "POST",
          body,
        }),
        invalidatesTags: ["User"],
      }
    ),
  }),
});

export const {
  useCreateUserMutation,
  useGetUsersQuery,
  useUpdateUserMutation,
  useToggleUserMutation,
} = userApi;
